import {
  Component,
  ChangeDetectionStrategy,
  DoCheck,
  Input
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-reactive-checkbox-input',
  templateUrl: './reactive-checkbox-input.component.html',
  styleUrls: ['./reactive-checkbox-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReactiveCheckboxInputComponent implements DoCheck {
  /**
   * 'fieldId' is a unique field identification
   * Example: 'email', 'password'
   *    ---REQUIRED PROPERTY---
   */
  @Input() isInline = false;
  @Input() filedLabel: string;
  @Input() filedId: string;
  @Input() onlyCheckbox: boolean;
  @Input() showTooltip = false;
  @Input() descriptionTooltip: string;
  @Input() topTooltipHover: number;
  @Input() leftTooltipHover: number;

  @Input() usingCheckBox = false;
  @Input() filedError: string;

  /**
   * 'control' is a reactive form validator/value controller
   *    ---REQUIRED PROPERTY---
   */
  @Input()
  control: AbstractControl;

  private _validationErrors = new BehaviorSubject<object>(null);
  public validationErrors$ = this._validationErrors.asObservable();

  ngDoCheck() {
    if (this.control && this.control.touched && this.control.invalid) {
      this._validationErrors.next(this.control['errors']);
    } else {
      this._validationErrors.next(null);
    }
  }
}
